'use client';

import { useRouter } from 'next/navigation';
import { web2app } from '@kcd/app-interface';

import { CloseIcon } from '~/assets/icons';

type Props = {
  path?: string;
};

export function CloseCurrentButton({ path }: Props) {
  const router = useRouter();
  const handleClose = () => {
    if (path) {
      router.replace(path);
      return;
    }

    web2app.closeCurrentModal({
      fallback: () => window.close(),
    });
  };

  return (
    <button type="button" onClick={handleClose} className="size-24">
      <CloseIcon className="" />
    </button>
  );
}
